import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import { Routes, Route } from 'react-router-dom';
import Main from './Main';
import HpExplorerPage from './products/hp_explorer';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/products/hp-explorer" element={<HpExplorerPage />} />
    </Routes>
  )
}

export default App